// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2yRfZ","rootCenter":"LoadMoreObserver_rootCenter__3rOwc","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1-lHu"};